import { render } from "./BlFormFieldColor.vue?vue&type=template&id=e8dc0944&scoped=true"
import script from "./BlFormFieldColor.vue?vue&type=script&lang=js"
export * from "./BlFormFieldColor.vue?vue&type=script&lang=js"

import "./BlFormFieldColor.vue?vue&type=style&index=0&id=e8dc0944&scoped=true&lang=scss"

import exportComponent from "/tmp/7c12f39a-5a06-429e-8ff2-90249d9b2982/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8dc0944"]])

export default __exports__